import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import { MoreCaseStudies } from '../../../../components'

import { meta } from '../../index.js'

export default class newscorp extends Component {
	render () {
		return (
			<React.Fragment>
				<Helmet
					title={meta.title.replace('blueshyft', 'News Corp')}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.url + meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.url + meta.image },
					]}
				/>
				
				<section className="case-study"> 

				    <div className="container">

				        <div className="title">

				            <a href="https://newscorpaustralia.com" target="_blank"><img src="/images/new/logos/news.svg"/></a>
				            <h3>Australia's no. 1 in Print & Digital</h3>
				            <p>Australia’s number one media company, News Corp Australia’s suite of digital and traditional print products provide 16 million Australians with news and information each month. The rise of digital print media has lowered barriers to publishing, generating a vast new marketplace for information, and transforming information seeking behaviours. In an effort to stay competitive in a dynamic market, News Corp Australia integrated with the blueshyft platform to build and deliver a new service, ‘Prepay & Save’.</p>

				        </div>

				        <div className="block">

				            <h4>Understanding the digital consumer</h4>
				            <p>News Corp Australia’s ‘Prepay & Save’ integration provides customers with a quick and cashless way to purchase newspapers at any one of blueshyft’s 1,500+ retailer locations across the country. News Corp customers can now top up their online accounts in-store via the blueshyft iPad, receiving every fifth newspaper purchased via the service, free. The integration addresses changing consumer needs, with streamlined digital processes and free newspapers rewarding loyal buyers and incentivising more regular newspaper consumption. For News Corp, this means:</p>

				            <div className="features">

				                <div className="feature">
				                    <img src="/images/new/icons/page-blue.svg"/>
				                    <p>In-store customer sign ups</p>
				                </div>
				                <div className="feature">
				                    <img src="/images/new/icons/map-blue.svg"/>
				                    <p>1,500+ convenient locations</p>
				                </div>
				                <div className="feature">
				                    <img src="/images/new/icons/analytics-blue.svg"/>
				                    <p>Retail customer data</p>
				                </div>

				            </div>
				    
				        </div>

				        <div className="block">

				            <h4>Revolutionising the retail experience</h4>
				            <p>News Corp Australia’s partnership with blueshyft provides customers with:</p>
				            <p>•  Added value - their  first paper free upon sign-up, and every fifth paper free thereafter</p>
				            <p>•  Convenience - 1,500+ locations Australia-wide</p>
				            <p>•  In-store sign ups - new customers can sign up with ease via the blueshyft iPad</p>

				        </div>

				        <div className="highlight">

				            <p>The Prepay & Save service has seen impressive increases in News Corp’s sales and customer retention. The integration has streamlined News Corp’s internal operational efficiency, improving the overall buyer experience for customers purchasing newspapers. As a result, the partnership has opened up new and improved digital purchasing avenues and incentives for buyers, serving as a point of differentiation with a competitive edge.  News Corp customers are reaping the benefits of convenience, accessibility and value.</p>
				    
				        </div>

				    </div>

				</section>

				<MoreCaseStudies cases={['lb', 'goget', 'sk']} />

			</React.Fragment>
		);
	}
};


// WEBPACK FOOTER //
// ./client/scenes/Clients/scenes/newscorp/index.js